export default __webpack_public_path__ + "static/media/actions-polygon.c676d1b1.svg";